module.exports = __webpack_public_path__ + "img/thumbnail_Bonobo_m_albino.d6cacd95.png";